module.exports = __webpack_public_path__ + "static/media/fisiognomi-assessment.1c091d81.png";